import React from "react";
import { withTheme } from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";
import { Theme } from "@rjsf/mui";
import { Paper, Box, Typography } from "@mui/material";

const Form = withTheme(Theme);

const schema = {
  type: "object",
  properties: {
    sortCollectionKey: {
      type: ["string", "null"],
      enum: ["sortByPopularTransactions", "sortByTrendingTransactions", "sortByRecentReviews"],
      uiEnumNames: ["Popular Transactions", "Trending Transactions", "Recent Reviews"],
      title: "Sort Collection By - optional"
    },
    filterByUserReviewsMinCount: {
      type: ["number", "null"],
      title: "Filter By User Reviews Min Count (optional)"
    },
    filterByUserReviewsMinRecommendedPercent: {
      type: ["number", "null"],
      title: "Filter By User Reviews Min Recommended Percent (optional - 0 means no filter)"
    }
  },
  additionalProperties: false
};

const uiSchema = {
  filterByUserReviewsMinCount: {
    "ui:widget": "updown",
    "ui:placeholder": "(none)"
  },
  filterByUserReviewsMinRecommendedPercent: {
    "ui:widget": "range",
    "ui:placeholder": "(none)",
    "ui:options": {
      min: 0,
      max: 100,
      step: 1,
      value: 0
    }
  },
  "ui:submitButtonOptions": { norender: true }
};

export const SortAndFilterInput = ({ sortAndFilterOptions = {}, onChange, disabled }) => {
  const handleChange = (formData) => {
    const cleanedData = { ...formData };

    if (cleanedData.filterByUserReviewsMinRecommendedPercent === null) {
      delete cleanedData.filterByUserReviewsMinRecommendedPercent;
    }

    if (cleanedData.filterByUserReviewsMinCount === null) {
      delete cleanedData.filterByUserReviewsMinCount;
    }

    if (cleanedData.sortCollectionKey === null) {
      delete cleanedData.sortCollectionKey;
    }

    // Only call onChange if there are actual values, otherwise pass empty object
    onChange(Object.keys(cleanedData).length > 0 ? cleanedData : {});
  };

  return (
    <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
      <Box>
        <Typography variant="subtitle1" fontWeight={600}>
          Sort And Filter Options {disabled ? "(disabled due to search terms)" : ""}
        </Typography>
      </Box>
      {!disabled && (
        <Form
          schema={schema}
          validator={validator}
          formData={sortAndFilterOptions}
          onChange={(e) => handleChange(e.formData)}
          uiSchema={uiSchema}
          formComponent={() => <React.Fragment />}
          style={{
            opacity: disabled ? 0.5 : 1,
            pointerEvents: disabled ? "none" : "auto"
          }}
        />
      )}
    </Paper>
  );
};
